import React from 'react';
import NavigationBar from '../navigationBar/NavigationBar';
import Footer from '../../pages/home/Footer';

const MarketingPageLayout = ({ children, pageClassName }) => (
    <div className={pageClassName}>
        <NavigationBar />
        {children}
        <Footer />
    </div>
);

export default MarketingPageLayout;

